// extracted by mini-css-extract-plugin
export var main = "Q9tIs";
export var title = "r4Im1";